import { ContentCard } from "@narmi/design_system";
import { ReactNode } from "react";
import styles from "./ProductTypeButton.module.css";

interface ProductTypeButtonProps {
  icon: ReactNode;
  name: string;
  onClick: () => void;
  subtext: string;
}

export function ProductTypeButton({ icon, name, onClick, subtext }: ProductTypeButtonProps) {
  return (
    <ContentCard onClick={onClick} kind="button">
      <div className={styles.buttonContent}>
        <div className={styles.buttonTextContainer}>
          <span className={`fontWeight--bold fontSize--xs fontColor--secondary ${styles.subtext}`}>
            {subtext}
          </span>
          <div className={styles.productNameLine}>
            <span className="fontSize--m fontWeight--semibold">{name}</span>
            <div aria-hidden="true" className="narmi-icon-arrow-right" />
          </div>
        </div>
        <div aria-hidden="true">{icon}</div>
      </div>
    </ContentCard>
  );
}
